import EventPriceSummaryModelBase from '../_generated/modelBases/event-price-summary-model-base';

export default class EventPriceSummaryModel extends EventPriceSummaryModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
